import { createAction } from "@reduxjs/toolkit";
import {
	BulkToggleWorkspaceRadioChannelsRequest,
	BulkToggleWorkspaceRadioChannelsResponse,
	CreateWorkspaceRadioChannelResponse,
	WorkspaceRadioChannelDto,
	WorkspaceRadioChannelUpdatedDto,
} from "@somewear/api";
import { createActionSet } from "@somewear/model";
import { WorkspaceRadioChannelRequest } from "@somewear/radio";

export const emitWorkspaceRadioChannelReceived = createAction<WorkspaceRadioChannelDto.AsObject>(
	"emitWorkspaceRadioChannelReceived",
);

export const emitWorkspaceRadioChannelUpdated =
	createAction<WorkspaceRadioChannelUpdatedDto.AsObject>("emitWorkspaceRadioChannelUpdated");

// Just called when we want to show a success/failure toast associated with the request.
export const SAVE_WORKSPACE_RADIO_CHANNELS_REQUEST_ID = "save-workspace-radio-channels-request";

export const workspaceRadioChannelActions = {
	queueWorkspaceRadioChannelToggle: createAction<Map<string, boolean>>(
		"queueWorkspaceRadioChannelToggle",
	),
	createWorkspaceRadioChannel: createActionSet<
		WorkspaceRadioChannelRequest,
		CreateWorkspaceRadioChannelResponse.AsObject
	>("workspace/radioChannel/create"),
	bulkToggleWorkspaceRadioChannels: createActionSet<
		BulkToggleWorkspaceRadioChannelsRequest.AsObject,
		BulkToggleWorkspaceRadioChannelsResponse.AsObject
	>("workspace/radioChannel/toggle"),
};
